import { createSelector } from '@reduxjs/toolkit';
import { stateKey } from '../../../app/state-key.js';
import { fieldSuggestionsOrderReducer as fieldSuggestionsOrder } from '../../../features/commerce/facets/field-suggestions-order/field-suggestions-order-slice.js';
import { executeSearch } from '../../../features/commerce/search/search-actions.js';
import { loadReducerError } from '../../../utils/errors.js';
import { buildController, } from '../../controller/headless-controller.js';
import { facetResponseSelector, isFacetLoadingResponseSelector, } from '../search/facets/headless-search-facet-options.js';
import { buildCategoryFieldSuggestions, } from './headless-category-field-suggestions.js';
/**
 * Builds a field suggestions generator controller for a given commerce engine.
 * @param engine The commerce engine.
 * @returns The field suggestions generator controller.
 *
 * @group Buildable controllers
 * @category FieldSuggestionsGenerator
 * @alpha
 * @deprecated
 */
export function buildFieldSuggestionsGenerator(engine) {
    if (!loadFieldSuggestionsGeneratorReducers(engine)) {
        throw loadReducerError;
    }
    const commonOptions = {
        fetchProductsActionCreator: executeSearch,
        facetResponseSelector,
        isFacetLoadingResponseSelector,
        facetSearch: { type: 'SEARCH' },
    };
    const controller = buildController(engine);
    const createFieldSuggestionsControllers = createSelector((state) => state.fieldSuggestionsOrder, (facetOrder) => facetOrder.map(({ type, facetId }) => {
        if (type !== 'hierarchical') {
            return;
        }
        return buildCategoryFieldSuggestions(engine, {
            facetId,
            ...commonOptions,
        });
    }));
    return {
        ...controller,
        get fieldSuggestions() {
            return createFieldSuggestionsControllers(engine[stateKey]).filter((v) => v !== undefined);
        },
        get state() {
            return engine[stateKey].fieldSuggestionsOrder;
        },
    };
}
function loadFieldSuggestionsGeneratorReducers(engine) {
    engine.addReducers({
        fieldSuggestionsOrder,
    });
    return true;
}
